module.exports = __webpack_public_path__ + "static/img/trainingbenefit1.39e4c478.png";